import React from "react"
import {
	BooleanProperty,
	StringProperty,
} from "../../@types/EpiFoundationSpa/Property"
import {
	Flex,
	Text,
	IconTypes,
	INNER_MAX_WIDTH,
	READABLE_LINE_MAX_WIDTH,
	Icon,
} from "@capioweb/ui-components/src"

interface AlertBlockProps {
	heading: StringProperty
	preamble: StringProperty
	icon?: StringProperty
	leftAligned?: BooleanProperty
	topMargin?: BooleanProperty
	fullWidth?: BooleanProperty
}

const AlertBlock: React.FC<AlertBlockProps> = ({
	heading,
	preamble,
	icon,
	leftAligned,
	topMargin,
	fullWidth,
}) => {
	return (
		<Flex as="section" w={1} px={3} pb={3} mt={topMargin?.value ? 3 : 0}>
			<Flex maxw={leftAligned ? INNER_MAX_WIDTH : 1} w={1} m="0 auto">
				<Flex
					maxw={fullWidth?.value ? 1 : READABLE_LINE_MAX_WIDTH}
					backgroundColor="coral33"
					w={1}
					px={{ _: 3, m: 5 }}
					py={{ _: 5, m: 7 }}
					borderRadius="24px 24px 24px 0"
					justifyContent="center"
				>
					<Flex
						flexGrow={1}
						maxw={READABLE_LINE_MAX_WIDTH}
						flexDirection="column"
						mx={leftAligned.value ? 0 : "auto"}
					>
						{icon.value && (
							<Flex
								minh={6}
								w={1}
								justifyContent={leftAligned?.value ? "start" : "center"}
								mb={0.5}
								ml={{
									_: leftAligned?.value && "-8px",
									m: leftAligned?.value && "-10px",
								}}
							>
								<Icon icon={icon.value as IconTypes} size={{ _: 6, m: 7.5 }} />
							</Flex>
						)}
						{heading.value && (
							<Text
								variant="headline-2"
								textAlign={leftAligned?.value ? "left" : "center"}
								mb={1.5}
							>
								{heading?.value}
							</Text>
						)}
						{preamble.value && (
							<Text textAlign={leftAligned?.value ? "left" : "center"} mb={1.5}>
								{preamble?.value}
							</Text>
						)}
					</Flex>
				</Flex>
			</Flex>
		</Flex>
	)
}

export { AlertBlock }
